<template>
  <b-modal
    header-close-content=""
    v-model="vm.openModalFromContextMenu"
    bodyClass="glossaryModal"
    :title="computedGlossaryTitle"
    size="xl"
    :id="modalName"
    ref="modal"
    @shown="init"
    @hide="handleCloseModal">
    <div class="container p-0" data-cy="glossary-modal">
      <b-overlay z-index="20" opacity="1" variant="white" no-wrap data-cy="spinnerLeft" :show="vm.mainSpinner">
        <template #overlay>
          <spinner size="48" />
        </template>
      </b-overlay>
      <grid-splitter>
        <template #left>
          <!-- START GLOSSARIES -->

          <div class="glossary overflow-auto">
            <div class="manipulation-area pb-3 pr-3">
              <button
                class="btn btn-with-icon mono"
                data-cy="add-glossary-btn"
                :disabled="vm.spinnerRightActive"
                @click="((vm.showAddUpdateGlossary = !vm.showAddUpdateGlossary), (vm.isAddGlossary = !vm.isAddGlossary))">
                <i class="mdp-Plus"></i>
                {{ $t("Glossary.NewGlossary") }}
              </button>
            </div>
            <div class="glossary-table pr-3 pt-0" v-if="!_.isEmpty(vm.glossaryItems)">
              <div class="glossary-table-header glossary-items">
                <div class="options-column"></div>
                <div class="glossary-table-col custom-width-col pl-1 mr-1">
                  <div>{{ $t("Glossary.Name") }}</div>
                </div>
                <div class="glossary-table-col value-col">
                  <div>{{ $t("Glossary.SourceLanguage") }}</div>
                </div>
                <div class="glossary-table-col value-col">
                  <div>{{ $t("Glossary.TargetLanguage") }}</div>
                </div>
                <div class="glossary-table-col active-col pl-0 mr-0">
                  <div>{{ $t("Glossary.Active") }}</div>
                </div>
              </div>
              <!-- START GLOSSARYTABLE -->
              <div class="glossary-table-row">
                <div class="glossary-table-row-container">
                  <div
                    class="glossary-table-row-data fallback-hint-container"
                    data-cy="glossary-table-row-data"
                    :class="{ active: vm.selectedGlossaryRowId === glossaryItem.id && vm.selectGlossary }"
                    v-for="(glossaryItem, key) in vm.glossaryItems"
                    :key="key">
                    <div class="options-column" @click="handleGlossarySelection(glossaryItem, key)">
                      <b-dropdown
                        no-caret
                        variant="primary"
                        class="table-option"
                        toggle-class="popup-menu-button"
                        menu-class="popup-menu"
                        :data-cy="'menu-' + glossaryItem.name">
                        <template #button-content>
                          <i class="mdp-Ellipsis"></i>
                        </template>
                        <b-dropdown-item
                          href="#"
                          link-class="menu-option last-option"
                          :data-cy="'glossary-edit-btn-' + glossaryItem.name"
                          @click="((vm.showAddUpdateGlossary = !vm.showAddUpdateGlossary), (vm.isUpdateGlossary = !vm.isUpdateGlossary))">
                          <span class="menu-icon"><i class="mdp-Edit"></i></span>
                          <span class="menu-text">{{ $t("Glossary.Edit") }}</span>
                        </b-dropdown-item>
                        <b-dropdown-item
                          href="#"
                          link-class="menu-option first-option"
                          :data-cy="'glossary-delete-btn-' + glossaryItem.name"
                          @click="deleteGlossary(glossaryItem, key)">
                          <span class="menu-icon"><i class="mdp-Delete"></i></span>
                          <span class="menu-text">{{ $t("Glossary.Delete") }}</span>
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>
                    <div
                      class="glossary-table-col custom-width-col pl-1 mr-1"
                      id="glossary-item-full-name"
                      v-tooltip="glossaryItem.name"
                      :data-cy="glossaryItem.name"
                      @click="handleGlossarySelection(glossaryItem, key)">
                      {{ glossaryItem.name }}
                    </div>
                    <div class="glossary-table-col value-col" @click="handleGlossarySelection(glossaryItem, key)">
                      {{ getDisplayName(vm.availableSourceLanguages, glossaryItem.sourceLanguage) }}
                    </div>
                    <div class="glossary-table-col value-col" @click="handleGlossarySelection(glossaryItem, key)">
                      {{ getDisplayName(vm.availableTargetLanguages, glossaryItem.targetLanguage) }}
                    </div>
                    <div
                      class="glossary-table-col active-col pl-0 mr-0"
                      @click="handleGlossarySelection(glossaryItem, key)"
                      :data-cy="'checkbox-' + glossaryItem.name">
                      <b-checkbox class="ml-2" v-model="glossaryItem.isActive" @change="isGlossaryActiveStateUpdatable(glossaryItem, key)" />
                    </div>
                  </div>
                </div>
              </div>
              <!-- END GLOSSARYTABLE -->
            </div>
            <div v-else class="pl-3">{{ $t("Glossary.AddNewGlossary") }}</div>
          </div>

          <!-- END GLOSSARIES -->
        </template>
        <template #right>
          <!-- START GLOSSARYENTRIESSECTION -->
          <div class="ml-3">
            <b-overlay z-index="20" opacity="1" variant="white" no-wrap data-cy="spinnerRight" :show="vm.spinnerRightActive && !vm.mainSpinner">
              <template #overlay>
                <spinner size="48" />
              </template>
            </b-overlay>
            <div class="glossary overflow-auto">
              <div class="manipulation-area pb-3">
                <b-row class="mx-0">
                  <b-col class="button-area pr-0" data-cy="add-glossary-entry-btn">
                    <button
                      class="btn btn-with-icon mono"
                      :disabled="!vm.selectGlossary || _.isEmpty(vm.glossaryItems) || _.isEmpty(vm.selectedGlossary) || vm.mainSpinner"
                      @click="addNewGlossaryEntry">
                      <i class="mdp-Plus"></i>
                      {{ $t("Glossary.NewWordPair") }}
                    </button>
                  </b-col>
                  <b-col class="button-area px-0">
                    <b-form-file v-show="false" id="importFileForGlossaryEntries" accept=".csv" v-model="vm.file"></b-form-file>
                    <button
                      class="btn btn-with-icon mono"
                      :disabled="!vm.selectGlossary || _.isEmpty(vm.glossaryItems) || _.isEmpty(vm.selectedGlossary) || vm.mainSpinner"
                      @click="importFile">
                      <i class="mdp-Upload"></i>
                      {{ $t("Glossary.Import") }}
                    </button>
                  </b-col>
                  <b-col class="button-area px-0">
                    <button
                      class="btn btn-with-icon mono"
                      :disabled="!vm.selectedGlossary || vm.hasUnsavedData || vm.mainSpinner"
                      @click="exportGlossaryEntries()">
                      <i class="mdp-Download"></i>
                      {{ $t("Glossary.Export") }}
                    </button>
                  </b-col>
                </b-row>
              </div>
              <!-- START GLOSSARYENTRIESTABLE -->
              <div class="glossary-table glossary-entries-table pt-0" v-if="!_.isEmpty(vm.glossaryEntries)">
                <div class="glossary-entry-table-header">
                  <div class="glossary-table-col options-column-entries"></div>
                  <b-row class="glossary-custom-row">
                    <b-col
                      ><div class="glossary-table-col header-entry-col pl-0">
                        <div>{{ getDisplayName(vm.availableSourceLanguages, vm.selectedGlossary?.sourceLanguage) }}</div>
                      </div></b-col
                    >
                    <b-col
                      ><div class="glossary-table-col header-entry-col pl-0">
                        <div>{{ getDisplayName(vm.availableTargetLanguages, vm.selectedGlossary?.targetLanguage) }}</div>
                      </div></b-col
                    >
                  </b-row>
                </div>
                <div class="glossary-entries-table-row">
                  <div class="glossary-table-row-container">
                    <div
                      class="glossary-table-row-data"
                      ref="glossaryEntriesRef"
                      :data-cy="'delete-glossary-entry-row' + key"
                      v-for="(glossaryEntryItem, key) in vm.glossaryEntries"
                      :key="key">
                      <div class="options-column-entries" :data-cy="'options-glossary-entry-btn' + key">
                        <b-dropdown no-caret variant="primary" class="table-option" toggle-class="popup-menu-button" menu-class="popup-menu">
                          <template #button-content>
                            <i class="mdp-Ellipsis"></i>
                          </template>
                          <b-dropdown-item
                            href="#"
                            link-class="menu-option first-option"
                            :data-cy="'delete-glossary-entry-btn' + key"
                            @click="deleteGlossaryEntryItem(key)">
                            <span class="menu-icon"><i class="mdp-Delete"></i></span>
                            <span class="menu-text">{{ $t("Glossary.Delete") }}</span>
                          </b-dropdown-item>
                        </b-dropdown>
                      </div>
                      <b-row class="glossary-custom-row">
                        <b-col
                          ><b-input
                            class="glossary-table-col entry-col mt-2"
                            :class="{ 'border-danger': !glossaryEntryItem.isValid }"
                            v-model="glossaryEntryItem.sourceLanguage"
                            :data-cy="glossaryEntryItem.isValid ? 'source-language-entry' + key : 'sl-border-danger' + key"
                            v-tooltip="glossaryEntryItem.errorMessage"
                        /></b-col>
                        <b-col>
                          <b-input
                            class="glossary-table-col entry-col mt-2"
                            :class="{ 'border-danger': !glossaryEntryItem.isValid }"
                            v-tooltip="glossaryEntryItem.errorMessage"
                            v-model="glossaryEntryItem.targetLanguage"
                            :data-cy="glossaryEntryItem.isValid ? 'target-language-entry' + key : 'tl-border-danger' + key" />
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pl-3" v-else-if="_.isEmpty(vm.glossaryItems)">{{ $t("Glossary.AddNewGlossaryAndEntry") }}</div>
              <div class="pl-3" v-else-if="_.isEmpty(vm.selectedGlossary)">
                {{ $t("Glossary.SelectGlossaryForGetEntries") }}
              </div>
              <div class="pl-3" v-else>{{ $t("Glossary.AddGlossaryEntry") }}</div>
              <!-- END GLOSSARYENTRIESTABLE -->
            </div>
          </div>
          <!-- END GLOSSARYENTRIESSECTION -->
        </template>
      </grid-splitter>
    </div>
    <template #modal-footer="{ cancel }">
      <b-button
        variant="primary"
        @click="updateGlossaryEntries()"
        :disabled="!vm.hasUnsavedData || isEveryGlossaryEntryUnique || isErrorMessage || vm.mainSpinner || vm.spinnerRightActive"
        data-cy="glossary-entries-save-btn"
        >{{ $t("Glossary.Save") }}</b-button
      >
      <b-button @click="cancel">{{ $t("close") }}</b-button>
    </template>
    <AddUpdateGlossaryModal
      v-model:show-modal="vm.showAddUpdateGlossary"
      :glossaryItems="vm.glossaryItems"
      :selectedGlossary="vm.selectedGlossary"
      :selectedSourceLanguage="vm.selectedSourceLanguage"
      :selectedTargetLanguage="vm.selectedTargetLanguage"
      :inputGlossaryName="vm.inputGlossaryName"
      :availableSourceLanguages="vm.availableSourceLanguages"
      :availableTargetLanguages="vm.availableTargetLanguages"
      :glossaryLanguagePairs="vm.glossaryLanguagePairs"
      :isUpdateGlossary="vm.isUpdateGlossary"
      :isAddGlossary="vm.isAddGlossary"
      @addOrUpdateFromModal="addOrUpdateGlossary">
    </AddUpdateGlossaryModal>
    <warning-modal
      id="warning-modal"
      v-if="vm.initialized && (!vm.isDeeplAuthorized || !vm.isDeeplAvailable || !vm.isImportFileValid)"
      v-model:show-modal="vm.openModalFromContextMenu"
      :title="vm.messages.title"
      :message="vm.messages.message"></warning-modal>
  </b-modal>
</template>
<script setup lang="ts">
import { RootState } from "@medapro-types/common/rootstate";
import { reactive, watch, onMounted, onBeforeUnmount, computed, ref, nextTick } from "vue";
import { useState } from "vuex-composition-helpers";
import { GlossaryTypes } from "@medapro-types/AttributeManager/GlossaryTypes";
import spinner from "@common/components/Spinner.vue";
import AddUpdateGlossaryModal from "./AddUpdateGlossaryModal.vue";
import GridSplitter from "@common/components/GridSplitter.vue";
import _ from "lodash";
import glossaryApi from "@services/glossary";
import { useI18n } from "vue-i18n";
import emitter from "tiny-emitter/instance";
import WarningModal from "../WarningModal.vue";

const { user } = useState<RootState>(["user"]);

const props = defineProps<{ modalName?: string }>();

const modal = ref();
const { t: $t } = useI18n();

const glossaryEntriesRef = ref<HTMLDivElement[]>([]);

//#region ViewModel
type ViewModel = {
  disableHandleGlossarySelection: boolean;
  openModalFromContextMenu: boolean;
  file: Array<string>;
  selectedGlossaryItemKey: number | undefined;
  glossaryItemKeyForGlossaryToDeactivate: number | undefined;
  isDelete: boolean;
  mainSpinner: boolean;
  spinnerRightActive: boolean;
  selectedOriginalGlossaryEntriesFormat: GlossaryTypes.GlossaryEntry[];
  selectGlossary: boolean;
  hasUnsavedData: boolean;
  doneFetching: boolean;
  isUpdateGlossary: boolean;
  isAddGlossary: boolean;
  selectedGlossary: GlossaryTypes.GlossaryItem | null;
  selectedGlossaryRowId: string;
  glossaryName: string;
  selectedSourceLanguage: GlossaryTypes.glossaryLanguage | null;
  selectedTargetLanguage: GlossaryTypes.glossaryLanguage | null;
  availableSourceLanguages: GlossaryTypes.glossaryLanguage[];
  availableTargetLanguages: GlossaryTypes.glossaryLanguage[];
  inputGlossaryName: string;
  inputSourceLanguage: string;
  inputTargetLanguage: string;
  showAddUpdateGlossary: boolean;
  startGlossaryEntriesToCompareChanges: GlossaryTypes.GlossaryEntry[];
  glossaryEntries: GlossaryTypes.GlossaryEntry[];
  glossaryItems: GlossaryTypes.GlossaryItem[];
  glossaryLanguagePairs: GlossaryTypes.getGlossaryLanguagePairs[];
  initialized: boolean;
  isDeeplAuthorized: boolean;
  isDeeplAvailable: boolean;
  isImportFileValid: boolean;
  messages: {
    title: string;
    message: string;
  };
};

const vm = reactive<ViewModel>({
  disableHandleGlossarySelection: false,
  openModalFromContextMenu: false,
  file: [],
  selectedGlossaryItemKey: undefined,
  glossaryItemKeyForGlossaryToDeactivate: 0,
  isDelete: false,
  mainSpinner: false,
  spinnerRightActive: false,
  selectedOriginalGlossaryEntriesFormat: [],
  selectGlossary: false,
  hasUnsavedData: false,
  doneFetching: false,
  isUpdateGlossary: false,
  isAddGlossary: false,
  selectedGlossary: null,
  selectedGlossaryRowId: "",
  glossaryName: "",
  availableSourceLanguages: [],
  availableTargetLanguages: [],
  selectedSourceLanguage: null,
  selectedTargetLanguage: null,
  inputGlossaryName: "",
  inputSourceLanguage: "",
  inputTargetLanguage: "",
  showAddUpdateGlossary: false,
  startGlossaryEntriesToCompareChanges: [],
  glossaryEntries: [],
  glossaryItems: [],
  glossaryLanguagePairs: [],
  initialized: false,
  isDeeplAuthorized: false,
  isDeeplAvailable: false,
  isImportFileValid: false,
  messages: {
    title: $t("translation.deepLTranslation"),
    message: $t("Activity.Description.DeepLAuthorizationFailed")
  }
});

//#endregion

//#region Validation

async function handleCloseModal(bvModalEvent: Event) {
  if (!vm.isImportFileValid && vm.isDeeplAuthorized && vm.isDeeplAvailable) {
    bvModalEvent.preventDefault();
    vm.isImportFileValid = true;
  }
  if (vm.hasUnsavedData) {
    if (!confirm($t("Glossary.DiscardUnsavedEntries"))) {
      bvModalEvent.preventDefault();
    }
  }
  vm.selectedGlossaryRowId = "";
  vm.selectedGlossaryItemKey = undefined;
}

function validateEntries(glossaryEntries: GlossaryTypes.GlossaryEntry[]) {
  let countEqualEntries = 0;
  let filteredGlossaryEntries: GlossaryTypes.GlossaryEntry[] = [];
  for (const entry of glossaryEntries) {
    entry.isValid = true;
    entry.errorMessage = "";
    if (glossaryEntries.length !== 1) {
      filteredGlossaryEntries = glossaryEntries.filter((x) => x !== entry);
      for (const entry2 of filteredGlossaryEntries) {
        if (entry.sourceLanguage.trim() == entry2.sourceLanguage.trim()) {
          countEqualEntries++;
          entry.isValid = false;
          entry.errorMessage = $t("Glossary.SourceLanguageEntryNameShouldBeUnique");
        }
        validationForEmptyLanguageEntries(entry);
        validationForStringLengthCheck(entry);
      }
    } else {
      for (const entry2 of glossaryEntries) {
        validationForEmptyLanguageEntries(entry2);
        validationForStringLengthCheck(entry2);
      }
    }
  }
  return countEqualEntries <= 1;
}

function validationForEmptyLanguageEntries(glossaryEntry: GlossaryTypes.GlossaryEntry) {
  if (glossaryEntry.sourceLanguage.trim() == "" && glossaryEntry.targetLanguage.trim() == "") {
    glossaryEntry.isValid = false;
    glossaryEntry.errorMessage = $t("Glossary.SourceAndTargetLanguageEntryNamesCouldNotBeBlanked");
  } else {
    if (glossaryEntry.sourceLanguage.trim() == "") {
      glossaryEntry.isValid = false;
      glossaryEntry.errorMessage = $t("Glossary.SourceLanguageEntryNameCouldNotBeBlanked");
    }
    if (glossaryEntry.targetLanguage.trim() == "") {
      glossaryEntry.isValid = false;
      glossaryEntry.errorMessage = $t("Glossary.TargetLanguageEntryNameCouldNotBeBlanked");
    }
  }
}

function validationForStringLengthCheck(glossaryEntry: GlossaryTypes.GlossaryEntry) {
  if (glossaryEntry.sourceLanguage.trim().length > 255 && glossaryEntry.targetLanguage.trim().length > 255) {
    glossaryEntry.isValid = false;
    glossaryEntry.errorMessage = $t("Glossary.SourceAndTargetLanguageEntriesCharLimitReached");
  } else {
    if (glossaryEntry.sourceLanguage.trim().length > 255) {
      glossaryEntry.isValid = false;
      glossaryEntry.errorMessage = $t("Glossary.SourceLanguageEntryCharLimitReached");
    }
    if (glossaryEntry.targetLanguage.trim().length > 255) {
      glossaryEntry.isValid = false;
      glossaryEntry.errorMessage = $t("Glossary.TargetLanguageEntryCharLimitReached");
    }
  }
}

const isEveryGlossaryEntryUnique = computed(() => {
  return !validateEntries(vm.glossaryEntries);
});

const isErrorMessage = computed(() => {
  let isErrorMessage = false;
  for (const entry of vm.glossaryEntries) {
    if (entry.isValid == false) {
      isErrorMessage = true;
      break;
    }
  }
  return isErrorMessage;
});

//#endregion

//#region Map / Unmap
function mapEntriesForGlossary(entriesForGlossary: Record<string, string>) {
  vm.glossaryEntries = [];
  vm.startGlossaryEntriesToCompareChanges = [];
  if (Object.entries(entriesForGlossary).length !== 0) {
    for (const [key, value] of Object.entries(entriesForGlossary)) {
      const result: GlossaryTypes.GlossaryEntry = {
        sourceLanguage: key,
        targetLanguage: value,
        isValid: true,
        errorMessage: ""
      };
      vm.glossaryEntries.push(result);
      vm.glossaryEntries.sort((x: GlossaryTypes.GlossaryEntry, y: GlossaryTypes.GlossaryEntry) =>
        x.sourceLanguage > y.sourceLanguage ? 1 : x.sourceLanguage < y.sourceLanguage ? -1 : 0
      );
      vm.startGlossaryEntriesToCompareChanges = _.cloneDeep(vm.glossaryEntries);
    }
  }
}

function unmapEntriesForGlossary(glossaryEntriesToUnmap: GlossaryTypes.GlossaryEntry[]) {
  const newArray = extractValuesFromArray(glossaryEntriesToUnmap);
  return newArray;
}

function extractValuesFromArray(glossaryEntriesToUnmap: GlossaryTypes.GlossaryEntry[]) {
  const result: Record<string, string> = {};
  glossaryEntriesToUnmap.forEach((obj) => {
    result[`${obj.sourceLanguage}`] = obj.targetLanguage;
  });

  return result;
}
//#endregion

//#region Manipulation / Helperfunctions
const computedGlossaryTitle = computed(() => {
  return $t("Glossary.Glossary");
});

function addNewGlossaryEntry() {
  let counter = 0;
  while (vm.glossaryEntries.filter((x) => x.sourceLanguage.includes(`(${counter})`) && x.targetLanguage.includes(`(${counter})`)).length > 0) {
    counter = counter + 1;
  }
  vm.glossaryEntries.push({
    sourceLanguage: `${$t("Glossary.NewEntry")} (${counter})`,
    targetLanguage: `${$t("Glossary.NewEntry")} (${counter})`,
    isValid: true,
    errorMessage: ""
  });
  nextTick(() => {
    scrollToLastElement();
  });
}

async function scrollToLastElement() {
  if (glossaryEntriesRef.value) {
    const index = glossaryEntriesRef.value.length - 1;
    const tableRow = glossaryEntriesRef.value[index];
    tableRow?.scrollIntoView({ behavior: "smooth" });
    const inputs = tableRow?.getElementsByTagName("input");
    if (inputs && inputs.length > 0) {
      inputs[0].focus();
    }
  }
}

function deleteGlossaryEntryItem(key: number) {
  vm.glossaryEntries.splice(key, 1);
}

function isDublicatedGlossar(targetObject: GlossaryTypes.GlossaryItem) {
  if (vm.isUpdateGlossary) {
    for (let i = 0; i < vm.glossaryItems.length; i++) {
      const obj = vm.glossaryItems[i];
      if (
        obj.id !== targetObject.id &&
        obj.name === targetObject.name &&
        obj.sourceLanguage === targetObject.sourceLanguage &&
        obj.targetLanguage === targetObject.targetLanguage
      ) {
        return true;
      }
    }
    return false;
  } else {
    for (let i = 0; i < vm.glossaryItems.length; i++) {
      const obj = vm.glossaryItems[i];
      if (obj.name === targetObject.name && obj.sourceLanguage === targetObject.sourceLanguage && obj.targetLanguage === targetObject.targetLanguage) {
        return true;
      }
    }
    return false;
  }
}

function resetFlagsFromGlossaryAddUpdate() {
  vm.mainSpinner = false;
  vm.spinnerRightActive = false;
  vm.isUpdateGlossary = false;
  vm.showAddUpdateGlossary = false;
  vm.inputGlossaryName = "";
  vm.selectedSourceLanguage = null;
  vm.selectedTargetLanguage = null;
}

async function getEntriesForSelectionHandler(glossaryItemForSelectionHandler: GlossaryTypes.GlossaryItem) {
  vm.spinnerRightActive = true;
  const glossaryEntriesResponse = await glossaryApi.getGlossaryEntries(glossaryItemForSelectionHandler);
  vm.selectedOriginalGlossaryEntriesFormat = glossaryEntriesResponse;
  mapEntriesForGlossary(glossaryEntriesResponse);
  vm.spinnerRightActive = false;
}

//#endregion

//#region Api section

async function updateGlossaryEntries() {
  if (!vm.selectedGlossary) return;
  vm.spinnerRightActive = true;
  const unmappedEntries = unmapEntriesForGlossary(vm.glossaryEntries);
  const mappedUpdateObject: GlossaryTypes.GlossaryItemToUpdate = {
    updateModel: vm.selectedGlossary,
    entries: unmappedEntries
  };
  try {
    if (_.isEmpty(unmappedEntries)) {
      vm.spinnerRightActive = true;
      const recreatedGlossary: GlossaryTypes.GlossaryItemToUpdate = {
        updateModel: {
          id: "",
          name: vm.selectedGlossary.name,
          sourceLanguage: vm.selectedGlossary.sourceLanguage,
          targetLanguage: vm.selectedGlossary.targetLanguage,
          isActive: vm.selectedGlossary.isActive
        }
      };
      await glossaryApi.deleteGlossary(vm.selectedGlossary);

      vm.hasUnsavedData = false;
      const dataFromUpdatedGlossary: GlossaryTypes.GlossaryItem = await glossaryApi.updateGlossary(recreatedGlossary);
      await reloadGlossaries();

      handleGlossarySelection(dataFromUpdatedGlossary, 0);

      resetFlagsFromGlossaryAddUpdate();
    } else {
      const updatedGlossaryResponse = await glossaryApi.updateGlossary(mappedUpdateObject);
      vm.selectedGlossaryRowId = updatedGlossaryResponse.id;
      const glossaryEntriesResponse = await glossaryApi.getGlossaryEntries(updatedGlossaryResponse);
      mapEntriesForGlossary(glossaryEntriesResponse);
      await reloadGlossaries();
      vm.spinnerRightActive = false;
    }
  } catch (err) {
    console.error(err);
  }
}

function isGlossaryActiveStateUpdatable(glossaryItem: GlossaryTypes.GlossaryItem, key: number | undefined) {
  vm.selectedGlossaryItemKey = key;
  if (vm.hasUnsavedData) {
    if (confirm($t("Glossary.DiscardUnsavedEntries"))) {
      vm.glossaryEntries = vm.startGlossaryEntriesToCompareChanges;
      vm.selectedGlossary = glossaryItem;
      vm.hasUnsavedData = false;
      updateGlossaryActiveState(glossaryItem);
    } else {
      vm.disableHandleGlossarySelection = true;
      glossaryItem.isActive = !glossaryItem.isActive;
    }
  } else {
    updateGlossaryActiveState(glossaryItem);
  }
}

async function updateGlossaryActiveState(glossaryItem: GlossaryTypes.GlossaryItem) {
  vm.mainSpinner = true;
  vm.selectedGlossary = glossaryItem;
  let filteredGlossaryItems = _.cloneDeep(vm.glossaryItems);
  const filteredGlossaryItemsToFindKeyIn = _.cloneDeep(vm.glossaryItems);
  filteredGlossaryItems = filteredGlossaryItems.filter((x) => x.id != glossaryItem.id);
  let glossaryItemToDeactivate: GlossaryTypes.GlossaryItem | undefined = undefined;
  glossaryItemToDeactivate = filteredGlossaryItems.find(
    (x) => x.sourceLanguage == glossaryItem.sourceLanguage && x.targetLanguage == glossaryItem.targetLanguage && x.isActive
  );

  filteredGlossaryItemsToFindKeyIn.forEach(function (x, index) {
    if (x.id !== glossaryItem.id && x.sourceLanguage == glossaryItem.sourceLanguage && x.targetLanguage == glossaryItem.targetLanguage && x.isActive) {
      vm.glossaryItemKeyForGlossaryToDeactivate = index;
    }
  });

  if (!glossaryItemToDeactivate && glossaryItem.isActive) {
    addOrUpdateGlossary(undefined, true, true);
  } else if (!glossaryItem.isActive) {
    addOrUpdateGlossary(undefined, true, false);
  } else {
    if (!glossaryItemToDeactivate) return;

    if (
      confirm(
        `${$t("Glossary.ActivateGlossary")} "${glossaryItem.name}" ${$t("Glossary.DeactivateGlossary")} "${glossaryItemToDeactivate.name}" ${$t(
          "Glossary.ForLanguagePair"
        )}`
      )
    ) {
      glossaryItem.isActive = false;
      const mappedDataFromGlossaryItemToDeactivate: GlossaryTypes.GlossaryItemToUpdate = {
        updateModel: {
          id: glossaryItemToDeactivate.id,
          name: glossaryItemToDeactivate.name,
          sourceLanguage: glossaryItemToDeactivate.sourceLanguage,
          targetLanguage: glossaryItemToDeactivate.targetLanguage,
          isActive: false
        }
      };
      try {
        const deactivatedGlossaryResponse = await glossaryApi.updateGlossary(mappedDataFromGlossaryItemToDeactivate);
        const glossaryItemToChangeActiveState = vm.glossaryItems.find((element) => element.id == glossaryItemToDeactivate?.id);
        if (!glossaryItemToChangeActiveState) return;
        glossaryItemToChangeActiveState.isActive = false;
        if (vm.glossaryItemKeyForGlossaryToDeactivate !== 0 && !vm.glossaryItemKeyForGlossaryToDeactivate) return;
        vm.glossaryItems.splice(vm.glossaryItemKeyForGlossaryToDeactivate, 1, deactivatedGlossaryResponse);
        addOrUpdateGlossary(undefined, true, true);
        glossaryItem.isActive = true;
      } catch (error) {
        vm.mainSpinner = false;
        console.error(error);
      }
    } else {
      vm.mainSpinner = false;
      glossaryItem.isActive = false;
      return;
    }
  }
}

async function deleteGlossary(glossaryItem: GlossaryTypes.GlossaryItem, key: number) {
  vm.isDelete = true;
  if (vm.hasUnsavedData) {
    if (!confirm($t("Glossary.DiscardUnsavedEntries"))) {
      vm.disableHandleGlossarySelection = true;
      return;
    }
  }
  if (!confirm($t("Glossary.DeleteGlossaryConfirmation"))) {
    return;
  }
  vm.glossaryEntries = vm.startGlossaryEntriesToCompareChanges;
  vm.mainSpinner = true;
  vm.selectGlossary = false;
  await glossaryApi.deleteGlossary(glossaryItem);
  vm.glossaryItems.splice(key, 1);
  vm.glossaryEntries = [];
  vm.selectedGlossary = null;
  vm.mainSpinner = false;
  vm.hasUnsavedData = false;
}

async function addOrUpdateGlossary(
  createdOrUpdatedGlossary: GlossaryTypes.GlossaryItemToUpdateExtended | undefined,
  setActiveState: boolean,
  activeState: boolean
) {
  if (vm.isUpdateGlossary) {
    if (!vm.selectedGlossary || createdOrUpdatedGlossary == undefined) return;
    vm.mainSpinner = true;

    const selectedGlossaryIndex = vm.glossaryItems.indexOf(vm.selectedGlossary);
    try {
      const dataFromUpdatedGlossary: GlossaryTypes.GlossaryItem = await glossaryApi.updateGlossary(createdOrUpdatedGlossary);
      vm.glossaryItems.splice(selectedGlossaryIndex, 1, dataFromUpdatedGlossary);
      handleGlossarySelection(dataFromUpdatedGlossary, undefined);
    } catch (error) {
      console.error(error);
    }
    resetFlagsFromGlossaryAddUpdate();
  } else if (setActiveState) {
    if (!vm.selectedGlossary) return;
    const createdOrUpdatedGlossaryActiveState = {
      updateModel: {
        id: vm.selectedGlossary.id,
        name: vm.selectedGlossary.name,
        sourceLanguage: vm.selectedGlossary.sourceLanguage,
        targetLanguage: vm.selectedGlossary.targetLanguage,
        isActive: activeState
      }
    };
    try {
      const updatedGlossaryItem = await glossaryApi.updateGlossary(createdOrUpdatedGlossaryActiveState);
      if (vm.selectedGlossaryItemKey == 0) {
        vm.selectedGlossaryItemKey = 0;
      } else {
        if (!vm.selectedGlossaryItemKey) return;
      }
      vm.glossaryItems.splice(vm.selectedGlossaryItemKey, 1, updatedGlossaryItem);
      handleGlossarySelection(updatedGlossaryItem, undefined);
    } catch (error) {
      console.error(error);
    }
    vm.mainSpinner = false;
  } else {
    vm.mainSpinner = true;

    const glossaryItemToCheckForDuplicates = {
      id: "",
      name: vm.inputGlossaryName,
      sourceLanguage: vm.selectedSourceLanguage?.languageCode as string,
      targetLanguage: vm.selectedTargetLanguage?.languageCode as string,
      isActive: false
    };
    if (createdOrUpdatedGlossary == undefined) return;
    if (!isDublicatedGlossar(glossaryItemToCheckForDuplicates)) {
      try {
        const dataFromUpdatedGlossary: GlossaryTypes.GlossaryItem = await glossaryApi.updateGlossary(createdOrUpdatedGlossary);
        await reloadGlossaries();
        handleGlossarySelection(dataFromUpdatedGlossary, undefined);
      } catch (error) {
        console.error(error);
      }
    }
    resetFlagsFromGlossaryAddUpdate();
  }
}

function handleGlossarySelection(glossaryItemForSelectionHandler: GlossaryTypes.GlossaryItem, key: number | undefined) {
  if (!vm.isDelete || !vm.disableHandleGlossarySelection) {
    if (vm.selectedGlossaryItemKey == key && vm.selectedGlossaryItemKey !== undefined) return;
    if (vm.hasUnsavedData) {
      if (!confirm($t("Glossary.DiscardUnsavedEntries"))) {
        return;
      }
    }
    vm.selectedGlossaryItemKey = key;
    vm.selectedGlossary = glossaryItemForSelectionHandler;
    vm.selectedGlossaryRowId = glossaryItemForSelectionHandler.id;
    if (vm.selectedOriginalGlossaryEntriesFormat == vm.glossaryEntries) {
      return;
    } else {
      getEntriesForSelectionHandler(glossaryItemForSelectionHandler);
    }
    vm.doneFetching = false;
    vm.hasUnsavedData = false;
    vm.selectGlossary = true;
  }
  vm.isDelete = false;
  vm.disableHandleGlossarySelection = false;
}

async function reloadGlossaries() {
  try {
    vm.mainSpinner = true;
    vm.glossaryItems = await glossaryApi.getGlossaries();
    vm.isDeeplAuthorized = true;
    vm.isDeeplAvailable = true;
    vm.isImportFileValid = true;
    vm.mainSpinner = false;
  } catch (error: any) {
    if (error && error.isAxiosError && error.response?.status == 409) {
      vm.isDeeplAuthorized = false;
    }
    if (error && error.isAxiosError && error.response?.status == 503) {
      vm.messages.message = $t("Glossary.DeeplIsNotAvailableMessage");
      vm.isDeeplAvailable = false;
    }
  }
}

function importFile() {
  const importPicker = document.getElementById("importFileForGlossaryEntries");
  if (vm.hasUnsavedData) {
    if (confirm($t("Glossary.DiscardUnsavedEntries"))) {
      if (importPicker !== null) {
        if (!vm.selectedGlossary) return;
        getEntriesForSelectionHandler(vm.selectedGlossary);
        importPicker.click();
      }
    } else {
      return;
    }
  } else {
    if (importPicker !== null) {
      importPicker.click();
    }
  }
}

async function exportGlossaryEntries() {
  try {
    if (!vm.selectedGlossary) return;
    const responseFile = await glossaryApi.exportGlossaryEntriesToFile(vm.selectedGlossary);
    const fileURL = window.URL.createObjectURL(new Blob([responseFile]));
    const exportFileLink = document.createElement("a");
    exportFileLink.href = fileURL;
    exportFileLink.setAttribute("download", `${vm.selectedGlossary?.name}.csv`);
    document.body.appendChild(exportFileLink);
    exportFileLink.click();
    document.body.removeChild(exportFileLink);
  } catch (error) {
    console.error(error);
  }
}

async function init() {
  if (vm.availableSourceLanguages.length === 0 || vm.availableTargetLanguages.length === 0) {
    loadlangauges();
  }
}

async function loadlangauges() {
  try {
    vm.glossaryLanguagePairs = await glossaryApi.getGlossaryLanguagePairs();
    vm.availableSourceLanguages = getUniqueSourceLanguages(vm.glossaryLanguagePairs);
    vm.availableTargetLanguages = getUniqueTargetLanguages(vm.glossaryLanguagePairs);
  } catch (error: any) {
    if (error?.response?.data.error == "UnAuthorized") {
      console.log($t("translation.deepLTranslation") + ": " + $t("Activity.Description.DeepLAuthorizationFailed"));
    } else {
      console.log($t("Activity.Description.DeepLTranslationFailed", { error: error?.response?.data.error ?? error.message }));
    }
    console.error(error);
  }
}

function getUniqueSourceLanguages(glossaryLanguagePairs: GlossaryTypes.getGlossaryLanguagePairs[]) {
  const uniqueLanguages: { [key: string]: GlossaryTypes.glossaryLanguage } = {};
  glossaryLanguagePairs.forEach((pair) => {
    uniqueLanguages[pair.sourceLanguage.languageCode] = pair.sourceLanguage;
  });
  return Object.values(uniqueLanguages).sort((a, b) => a.displayName.localeCompare(b.displayName));
}

function getUniqueTargetLanguages(glossaryLanguagePairs: GlossaryTypes.getGlossaryLanguagePairs[]) {
  const uniqueLanguages: { [key: string]: GlossaryTypes.glossaryLanguage } = {};
  glossaryLanguagePairs.forEach((pair) => {
    uniqueLanguages[pair.targetLanguage.languageCode] = pair.targetLanguage;
  });
  return Object.values(uniqueLanguages).sort((a, b) => a.displayName.localeCompare(b.displayName));
}

function getDisplayName(source: GlossaryTypes.glossaryLanguage[], languageCode?: string) {
  const language = source.find((x) => x.languageCode === languageCode);
  return language ? language.displayName : "";
}

function getGlossaryLangauge(source: GlossaryTypes.glossaryLanguage[], languageCode?: string) {
  const language = source.find((x) => x.languageCode === languageCode);
  return language ? language : null;
}

//#endregion

//#region Watcher

watch(
  () => vm.glossaryItems,
  () => {
    vm.glossaryItems.sort((x: GlossaryTypes.GlossaryItem, y: GlossaryTypes.GlossaryItem) => (x.name > y.name ? 1 : x.name < y.name ? -1 : 0));
  },
  { deep: true, immediate: true }
);

watch(
  () => vm.file,
  async () => {
    if (!_.isEmpty(vm.file)) {
      try {
        vm.mainSpinner = true;

        if (!vm.selectedGlossary) return;
        const UpdatedGlossaryItemResponse = await glossaryApi.importGlossaryEntriesFromFile(vm.selectedGlossary, vm.file);
        await reloadGlossaries();
        handleGlossarySelection(UpdatedGlossaryItemResponse, undefined);
        vm.file = [];
      } catch (error: any) {
        let errorMessage = "";
        if (error && error.isAxiosError) {
          if (error.response?.status == 409) {
            console.error(error);
            errorMessage = $t("Glossary.ImportWrongFileType");
          }
          if (error.response?.status === 400 && error.response.data?.File && error.response.data.File.length > 0) {
            errorMessage = $t("api.errors." + error.response.data.File[0]);
          } else {
            errorMessage = $t("Glossary.ImportWrongFileType");
          }
          vm.messages.message = errorMessage;
          vm.isImportFileValid = false;
          vm.file = [];
        }
      } finally {
        vm.mainSpinner = false;
      }
    }
  },
  { deep: true }
);

watch(
  () => vm.glossaryEntries,
  () => {
    if (vm.doneFetching) {
      if (JSON.stringify(vm.glossaryEntries) == JSON.stringify(vm.startGlossaryEntriesToCompareChanges)) {
        vm.hasUnsavedData = false;
      } else {
        if (_.isEmpty(vm.selectedGlossary)) {
          vm.hasUnsavedData = false;
        } else {
          vm.hasUnsavedData = true;
        }
      }
    }
    vm.doneFetching = true;
  },
  { deep: true }
);

watch(
  () => vm.showAddUpdateGlossary,
  async () => {
    if (!vm.isUpdateGlossary) {
      vm.isAddGlossary = vm.showAddUpdateGlossary;
    }

    if (vm.showAddUpdateGlossary) {
      if (vm.hasUnsavedData) {
        if (confirm($t("Glossary.AddUpdateWithUnsavedEntries"))) {
          vm.glossaryEntries = vm.startGlossaryEntriesToCompareChanges;
          vm.hasUnsavedData = false;
        } else {
          vm.showAddUpdateGlossary = false;
          return;
        }
      }
      vm.inputGlossaryName = "";
      vm.selectedSourceLanguage = null;
      vm.selectedTargetLanguage = null;
      if (vm.isUpdateGlossary && vm.selectedGlossary) {
        vm.inputGlossaryName = vm.selectedGlossary.name;
        vm.selectedSourceLanguage = getGlossaryLangauge(vm.availableSourceLanguages, vm.selectedGlossary?.sourceLanguage);
        vm.selectedTargetLanguage = getGlossaryLangauge(vm.availableTargetLanguages, vm.selectedGlossary?.targetLanguage);
      }
    } else {
      vm.inputGlossaryName = "";
      vm.selectedSourceLanguage = null;
      vm.selectedTargetLanguage = null;
      vm.isUpdateGlossary = false;
    }
    vm.doneFetching = true;
  },
  { deep: true }
);

watch(
  () => modal.value?.isShow,
  async () => {
    if (modal.value?.isShow) {
      if (user.value.isDeeplAuthorized) {
        await reloadGlossaries();
        vm.initialized = true;
        if (vm.glossaryItems && vm.glossaryItems.length > 0) {
          handleGlossarySelection(vm.glossaryItems[0], 0);
        }
      }
    } else {
      vm.glossaryItems = [];
      vm.glossaryEntries = [];
      vm.selectedGlossary = null;
      vm.selectGlossary = false;
      vm.hasUnsavedData = false;
      vm.initialized = false;
    }
  },
  {}
);
//#endregion

//#region Lifecycle hooks

function modalOpenEventHandler() {
  if (props.modalName == "glossary-modal-attribute-tab") {
    vm.openModalFromContextMenu = true;
  }
}

onMounted(() => {
  emitter.on("open-glossary-modal-from-context-menu", modalOpenEventHandler);
});

onBeforeUnmount(() => {
  emitter.off("open-glossary-modal-from-context-menu", modalOpenEventHandler);
});
//#endregion
</script>
